import { Box, Container, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { theme } from '../../App';
import { NAVBAR_SPACE } from '../Navbar/Navbar';
import { Motion } from '../Motion/Motion';
import { navbarBlue } from '../../Classes/theme';
import { Link } from 'react-router-dom';
import ImageDialog from '../ImageDialog/ImageDialog';

export default function AboutApp({ appPageData = {}, negativeRotate = false }) {
    const mobile = useMediaQuery(theme.breakpoints.down("md"));
    const tablet = useMediaQuery("(max-width:1050px)");

    const textSize = tablet ? "360px" : "420px";

    return (
        <Container maxWidth='lg' sx={{ py: { xs: '40px', sm: '40px', md: '80px' }, px: NAVBAR_SPACE }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: mobile ? 'wrap' : 'nowrap' }}>
                <Box sx={{ textAlign: 'left', minWidth: textSize, maxWidth: textSize }}>
                    <Typography variant='blue' sx={{ mb: '18px' }}>Aplikace</Typography>
                    <Typography variant='big' sx={{ mb: '18px' }}>{appPageData.title}</Typography>
                    <Typography sx={{ ml: '5px', mb: '36px' }}>{appPageData.text}</Typography>
                    <Motion>
                        <Box

                            sx={{
                                bgcolor: navbarBlue,
                                height: "52px",
                                minWidth: '120px',
                                width: "fit-content",
                                borderRadius: "42px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",

                            }}

                        >
                            <Link style={{
                                width: '100%', height: '100%', display: "flex",
                                alignItems: "center",
                                justifyContent: "center", textDecoration: 'none'
                            }} to={appPageData.link}>
                                <Typography
                                    sx={{ mx: "30px", mt: '2px' }}
                                    variant="button"
                                >
                                    Více
                                </Typography>
                            </Link>
                        </Box>
                    </Motion>
                </Box>
                <Box sx={{
                    mt: mobile ? '60px' : '0px', pl: { md: '20px', lg: '64px' }, ml: 'auto', display: 'flex',
                    position: 'relative', justifyContent: 'center', alignItems: 'center', alignContent: 'center'
                }}>
                    <ImageDialog>
                        {<picture>
                            <source srcSet={appPageData.offersImage} type="image/webp" />
                            <Box
                                component="img"
                                alt="Ukázka"
                                src={appPageData.offersImage}
                                sx={[
                                    {
                                        height: 'auto',
                                        width: '100%',
                                        /*transform: "rotate(0deg)",
                                        transitionDuration: "200ms",
                                        '&:hover': {
                                            transform: `rotate(${negativeRotate ? '-' : ''}5deg)`,
                                        }*/
                                    },

                                ]}
                            />
                        </picture>}
                    </ImageDialog>
                </Box>
            </Box>
        </Container>

    )
}
